import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsAimRule26ContentSectionCls: string;
		}
	},

	slug: string
}

class Info extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Aim Rule 26 Info Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAimRule26ContentSectionCls || '', 'investors_aim_rule_26_list', { animCls: 'animate__fadeIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Info;